import { useEffect } from 'react';

import { useRecoilState, useRecoilValue } from 'recoil';

import { RightSideBarTab } from 'types';
import { rightSideBarFullState, rightSideBarTabState, selectedNodeState } from 'state/atoms';

const useTabBar = () => {
  const [selectedTab, setSelectedTab] = useRecoilState(rightSideBarTabState);
  const [isFull, setIsFull] = useRecoilState(rightSideBarFullState);
  const selectedNode = useRecoilValue(selectedNodeState);

  const handleTabClick = (newTab: RightSideBarTab) => {
    if (selectedTab === newTab) {
      setSelectedTab(undefined);
    } else {
      setSelectedTab(newTab);
    }
  };

  const handleToggleFull = () => {
    setIsFull((prev) => !prev);
  };

  useEffect(() => {
    if (!selectedNode && (selectedTab === 'nodeInfo' || selectedTab === 'nodeSetting')) {
      setSelectedTab(undefined);
    }
  }, [selectedTab, selectedNode, setSelectedTab]);

  return {
    selectedTab,
    selectedNode,
    isFull,
    onTabClick: handleTabClick,
    onToggleFull: handleToggleFull,
  };
};

export default useTabBar;
